import { Component, Prop, h, Listen, Event, EventEmitter, Element, Host, State } from '@stencil/core';
import state from './pn-profile-modal-store';
import { arrow_left } from 'pn-design-assets/pn-assets/icons.js';
@Component({
  tag: 'pn-profile-modal-profile',
  styleUrl: 'pn-profile-modal-profile.scss',
})
export class PnProfileModalProfile {
  @Element() hostElement: Element;

  @Prop({ reflect: true }) heading: string = null;
  @Prop({ reflect: true }) description: string = null;
  @Prop({ reflect: true }) url: string = null;
  @Prop({ mutable: true }) selected: boolean = false;
  @Prop({ reflect: true }) showCustomerNumbers: boolean = false;

  @Prop({ reflect: true }) pleaseSelectText: string = '';

  @Prop({ mutable: true, reflect: true }) visible: boolean = false;

  @Event() urlSelected: EventEmitter;
  @Event() showCustomerNumbersEvent: EventEmitter;

  @State() identifier: string = '';

  componentWillLoad() {
    this.identifier = this.heading + this.url;
  }

  onProfileOptionClick() {
    this.selected = true;
    if (this.url) {
      this.urlSelected.emit(this.url);
      // TODO: emit event with URL to parent
    } else {
      // TODO: Open customer number selection
      state.selectedProfile = this.identifier;
    }
  }
  render() {
    return (
      <Host selected={this.selected + ''}>
        <div class="pn-profile-modal-profile-listitem" aria-hidden={!!state.selectedProfile + ''}>
          <button class="pn-profile-modal-profile-listitem-button" onClick={this.onProfileOptionClick.bind(this)}>
            <div class="pn-profile-modal-profile-listitem-heading">{this.heading}</div>
            <div class="pn-profile-modal-profile-listitem-description">{this.description}</div>
          </button>
        </div>
        <div class="pn-profile-modal-profile-details" aria-hidden={!(state.selectedProfile === this.identifier) + ''}>
          <pn-button
            appearance="light"
            variant="borderless"
            icon={arrow_left}
            left-icon="true"
            small="true"
            onClick={() => {
              this.selected = false;
              state.selectedProfile = '';
            }}
          >
            {state.i18n.toText} {state.selectedType}
          </pn-button>
          <div class="pn-profile-modal-profile-details-company">
            <div class="pn-profile-modal-profile-details-label">{state.i18n.choosenCompanyText}</div>
            <div class="pn-profile-modal-profile-details-company-heading">{this.heading}</div>
            <div class="pn-profile-modal-profile-details-company-description">{this.description}</div>
          </div>
          <div class="pn-profile-modal-profile-details-list">
            <div class="pn-profile-modal-profile-details-list-label">{this.pleaseSelectText}</div>
            <slot />
          </div>
        </div>
      </Host>
    );
  }
}
